const openLink = function(
  link: string | undefined,
  openInNewTab: boolean
): void {
  window.open(
    link || "",
    openInNewTab ? "_blank" : "_self",
    "noopener,noreferrer"
  );
};

const windowUtils = {
  openLink
};
export default windowUtils;
